export function isOpen(sop_sub) {
    if (!sop_sub.last_submitted) return true;
    let now = new Date();
    let first = new Date(now.getFullYear(), now.getMonth(), 1);
    let date = new Date(Date.parse(sop_sub.last_submitted));
    return date < first;
}

export function isClosed(sop_sub) {
    if (!sop_sub.last_submitted) return false;
    let now = new Date();
    let first = new Date(now.getFullYear(), now.getMonth(), 1);
    let date = new Date(Date.parse(sop_sub.last_submitted));
    return date > first;
}
